export const english = {
  common: {
    valueTooHigh: 'The value cannot be higher than',
    valueTooLow: 'The value must be at least',
    minLengthNew: 'The minimum length is',
    maxLengthNew: 'The maximum length is',
    invalidFormat: 'Invalid format',
    lbl_email: 'E-mail',
    placeholder_email: 'Write your E-mail here',
    lbl_password: 'Password',
    placeholder_password: 'Write your Password here',
    text_forget_password: 'Forgot password',
    placeholder_write_here: 'Write here...',
    button_next: 'NEXT',
    button_skip: 'SKIP',
    placeholder_options: 'Select...',
    placeholder_enter_value: 'Enter value',
    lbl_business_sector: 'Business Sector',
    business_sector_option_trade: 'Trade',
    business_sector_option_commerce: 'Commerce',
    business_sector_option_industry: 'Industry',
    business_sector_option_manufacturing: 'Manufacturing',
    business_sector_option_craft_artisanal: 'Craft & Artisanal',
    business_sector_option_agriculture: 'Agriculture',
    business_sector_option_construction: 'Construction',
    business_sector_option_transport_logistics: 'Transport & Logistics',
    business_sector_option_energy_utilities: 'Energy & Utilities',
    business_sector_option_ict_software: 'ICT & Software',
    business_sector_option_finance_insurance: 'Finance & Insurance',
    business_sector_option_healthcare_personal_services:
      'Healthcare & Personal Services',
    business_sector_option_education_training: 'Education & Training',
    business_sector_option_tourism_hospitality: 'Tourism & Hospitality',
    business_sector_option_real_estate: 'Real Estate',
    business_sector_option_public_administration: 'Public Administration',
    business_sector_option_other: 'Other',
    business_sector_option_services: 'Services',
    lbl_company_name: 'Company name',
    lbl_vat_number: 'VAT number',
    lbl_address: 'Address',
    lbl_street: 'Street / Address',
    lbl_postal_code: 'Postal Code',
    lbl_city: 'City',
    lbl_province: 'Province',
    lbl_pec: 'PEC (Certified Email)',
    lbl_sdi_code: 'SDI Code (optional)',
    button_report: 'REPORT',
    button_close: 'CLOSE',
    lbl_name: 'Name',
    lbl_surname: 'Surname',
    lbl_phone_number: 'Phone number',
    lbl_company_role: 'Company role',
    company_role_option_consultant: 'Consultant',
    lbl_no_of_employees: 'Number of employees',
    button_return: 'RETURN',
    button_edit: 'Edit',
    profile: 'Profile',
    loading: 'Loading',
    required: 'required',
    recommended: 'recommended',
    country: 'Country',
    back: 'Back to platform',
    jan: 'January',
    feb: 'February',
    mar: 'March',
    apr: 'April',
    may: 'May',
    jun: 'June',
    jul: 'July',
    aug: 'August',
    sep: 'September',
    oct: 'October',
    nov: 'November',
    dec: 'December',
    annual: 'Annual',
    isInvalid: 'is invalid',
    isRequired: 'is required',
    minLength: 'Invalid phone number',
    maxLength: 'Limit exceeded',
    passwordMismatch: 'Passwords do not match',
    subscribe: 'SUBSCRIBE',
    noData: 'No Calculations',
    stas: 'Subscription plan type and services',
    cttop: 'Choose the type of subscription that best suits your needs',
    mp: 'monthly plans',
    ap: 'annual plans',
    ss: 'Subscription successful',
    su: ' Subscription unsuccessful',
    profileUpdated: 'Profile updated successfully',
    profileUpdateFailed: 'Failed to update profile',
    sp: 'Subscribed plan',
    a: 'Active',
    so: 'Subscribed on',
    cancelSubscription: 'Cancel Subscription',
    cancelSubscriptionConfirm:
      'Are you sure you want to cancel your subscription?',
    cancelSubscriptionWarning:
      'Your subscription will remain active until the end of your current billing period. After that, access will be deactivated.',
    subscriptionCancelled: 'Subscription cancelled successfully',
    cancel: 'Cancel',
    confirm: 'Confirm',
    billingCycle: 'Billing cycle',
    monthly: 'Monthly',
    yearly: 'Yearly',
    validUntil: 'Valid until',
    cancelSubscriptionError: 'Failed to cancel subscription. Please try again.',
    na: 'Active plan does not allow Training',
    login_required: 'Please login to continue',
    usertype_option_food_beverage: 'Food & Beverage Manufacturing',
    usertype_option_chemical_pharma: 'Chemical / Pharmaceutical',
    usertype_option_automotive: 'Automotive',
    usertype_option_plastics_rubber: 'Plastics & Rubber',
    usertype_option_metal_fabrication: 'Metal Fabrication',
    usertype_option_electronics: 'Electronics / Semiconductors',
    usertype_option_textile_apparel: 'Textile & Apparel',
    usertype_option_packaging: 'Packaging',
    usertype_option_logistics: 'Logistics / Warehousing',
    usertype_option_other_custom: 'Other (custom)',
    otherBusinessSector: 'Specify Business Sector',
    otherBusinessSectorPlaceHolder: 'Enter your business sector',
    calculation: 'Calculation',
  },
  login: {
    heading: 'Welcome back',
    sub_dont_have_account: "Don't have an account?",
    sub_dont_have_account_s: 'Create one now.',
    button_login: 'Login',
    remember_password: 'Remember password',
    resent: 'OTP sent! Check your inbox.',
  },
  forgot_password: {
    heading: 'Forgot Password',
    subheading: 'Enter your email address to receive the verification code.',
    button_send_code: 'SEND CODE',
    button_back_to_login: 'Back to login',
  },
  register: {
    heading: 'Welcome',
    sub_already_have_account: 'Already have an account?',
    sub_already_have_account_s: 'Login to the portal.',
    lbl_usertype: 'User type',
    placeholder_usertype: 'Select user type',
    usertype_option_company: 'Company',
    usertype_option_consultant: 'Consultant',
    lbl_repeat_password: 'Repeat password',
    button_create: 'CREATE NEW ACCOUNT',
    usertype_option_site_director: 'Site Director / Plant Manager',
    usertype_option_environmental_manager: 'Environmental Manager',
    usertype_option_hse_officer: 'HSE (Health-Safety-Environment) Officer',
    usertype_option_production_supervisor: 'Production Supervisor',
    usertype_option_quality_manager: 'Quality Manager',
    usertype_option_maintenance_lead: 'Maintenance Lead',
    usertype_option_supply_chain_coordinator: 'Supply-Chain Coordinator',
  },
  register_confirm_otp: {
    heading: 'We Emailed You',
    subheading:
      'Your code is on way. To log in, enter the code we emailed you. It may take a few minutes to arrive.',
    lbl_confirmation_code: 'Confirmation code',
    button_confirm: 'Confirm',
    button_resend_code: 'Resend code',
  },
  inform_step_1: {
    heading: 'STEP 1',
    subheading: 'Profile info',
  },
  inform_step_2: {
    heading: 'STEP 2',
    subheading: 'Company info',
  },
  inform_step_3: {
    heading: 'STEP 3',
    subheading: 'Subscription info',
    info_title:
      'Congratulations, you now have 2 videos available in your profile.',
    info_subtitle:
      'In this step, you have access to two valuable tools to start using the software at its best! Both contents are available in your personal area and you can consult them whenever you need them. Take the time to review the materials and acquire the skills that will help you make the most of our software.',
    button_play_now: 'PLAY NOW',
    button_confirm: 'CONFIRM',
  },
  dashboard: {
    header_carbon_footprint: 'Carbon Footprint',
    header_emissions: 'Stakeholder Engagement',
    header_profile: 'Profile',
    sidebar_favorites: 'Favorites',
    sidebar_no_favorites: 'No favorite companies',
    sidebar_companies: 'Companies',
    sidebar_no_companies: 'No companies added',
    button_new_company: 'NEW COMPANY',
    training: 'Training',
  },
  form_company_registration: {
    heading: 'Company Registration',
    subheading:
      'Here you can add companies for which you want to calculate the carbon footprint and manage the related data. To get started, fill in the required fields. The added companies will be displayed in the list on the left, with the company name and logo.',
    lbl_company_type: 'Company type',
    placeholder_company_type: 'Select a company type',
    company_type_option1: 'Individual',
    company_type_option2: 'Legal Entity',
    placeholder_business_sector: 'Select a business sector',
    lbl_contact_phone: 'Contact phone',
    lbl_contact_email: 'Contact email',
    lbl_company_logo: 'Company Logo',
    button_upload: 'UPLOAD',
    button_add_now: 'ADD NOW',
  },
  profile: {
    heading_video_available: 'Videos available',
    subheading_video_available:
      'Take the time to review the materials and acquire the skills that will help you get the most out of our software.',
    heading_profile_info: 'Profile information',
    subheading_profile_info:
      'Here you can add and edit your information and find content dedicated to you.',
    button_save: 'SAVE',
  },
  company_item: {
    heading: 'Give your calculation a name',
    subheading:
      "Start by giving your new carbon footprint calculation a name. This name will help you easily identify your report among existing reports. For example, you can use the company name followed by the reporting year or quarter, such as 'CompanyXYZ Calculation Q3 2024'.",
    lbl_calculation_name: 'Calculation name',
    placeholder_calculation_name: 'Enter calculation name',
    button_start_calculation: 'START CALCULATION',
    table_heading: 'Active calculations',
    table_subheading:
      'After answering the questions for each category, you can confirm the calculation to save it in this report table. You can edit later if necessary.',
    table_col_name: 'Name',
    table_col_date: 'Date',
    table_col_category: 'Category',
    table_col_completion: 'Completion',
    table_col_status: 'Available actions',
    table_col_action: 'Action',
  },
  carbon: {
    heading: 'Compilation of emission categories',
    subheading:
      'The carbon footprint calculation is based on the analysis of the three categories defined by the GHG Protocol (Greenhouse Gas Protocol). Answering the following questions will allow you to complete the emissions profile of your company',
    subpoint1: 'Category 1, Direct emissions',
    subpoint1_data:
      "Direct emissions: These are emissions generated directly by the company's activities, such as fuel consumption in company vehicles or the use of boilers.",
    subpoint2: 'Category 2, Indirect emissions',
    subpoint2_data:
      'This includes emissions resulting from the consumption of electricity, heating or cooling purchased by the company.',
    subpoint3: 'Category 3, 4, 5, 6, Other indirect emissions',
    subpoint3_data:
      'This Scope includes emissions from the entire supply chain, such as business travel, the procurement of raw materials, or waste management.',
  },
  emission: {
    heading: 'Stakeholder Engagement',
    subheading:
      "Track the progress of companies you have invited to calculate their carbon footprint. Monitor each stakeholder's journey from invitation through completion.",
    associated_companies: 'Invited Stakeholders',
    associated_companies_desc:
      'View and manage companies invited to calculate their carbon footprint',
    generate_invite: 'Generate Invite Link',
    invite_link_generated: 'Invite link generated!',
    copy_link: 'Copy Link',
    link_copied: 'Link copied to clipboard!',
    link_expires: 'This link expires in 7 days',
    link_never_expires: 'This link is permanent and never expires',
    no_linked_companies: 'No invited stakeholders yet',
    no_linked_companies_desc:
      'Send an invite to companies you want to engage for carbon footprint calculation.',
    company_name: 'Company / Email',
    status: 'Status',
    actions: 'Actions',
    status_invited: 'Invited',
    status_registered: 'Registered',
    status_started: 'Started',
    status_completed: 'Completed',
    status_accepted: 'Registered',
    remove: 'Remove',
    remove_confirm: 'Are you sure you want to remove this stakeholder?',
    invite_title: 'You have been invited!',
    invite_desc:
      "has invited you to calculate your company's carbon footprint.",
    accept_invite: 'Accept Invite',
    select_company: 'Select Company',
    select_company_desc: 'Choose which company to link with the inviter',
    invite_accepted: 'Invite accepted successfully!',
    invite_expired: 'This invite link has expired',
    invite_invalid: 'Invalid invite link',
    login_to_accept: 'Please login to accept this invite',
    create_account_first: 'Create an account to accept this invite',
    invite_company: 'Invite Company',
    invite_company_desc: 'Send an invitation to a company',
    invitee_email: 'Invitee Email Address',
    send_invite: 'Send Invitation',
    invite_sent: 'Invitation sent successfully!',
    invite_error: 'Failed to send invitation. Please try again.',
    your_invite_link: 'Your Invite Link',
    your_invite_link_desc:
      'Share this link with companies you want to invite for carbon footprint calculation',
    generate_new_link: 'Generate New Link',
    email_column: 'Email',
    invite_date: 'Invite Date',
    last_activity: 'Last Activity',
    total_invited: 'Invited',
    total_registered: 'Registered',
    total_started: 'Started',
    total_completed: 'Completed',
    total: 'Total',
  },
  category: {
    heading_category: 'Category',
    subheading_category: 'Question',
    subheading_category_s: 'of',
    category_doubts: 'Doubts',
    category_info: 'Info',
    info_category: 'Category',
    info_name: 'Name',
    info_region: 'Region',
    info_source: 'Source',
    info_source_dataset: 'Source Dataset',
    heading_steps_completed: 'Step completed!',
    subheading_steps_completed:
      "You have answered all the questions in this section. To continue to the next step, click on the arrow. Look at your company's emissions, already at this point in the report.",
    heading_questionnaire_summary: 'Questionnaire summary',
    subheading_questionnaire_summary:
      'Scroll through all the questions or search for the ones you want to view.',
    button_edit: 'EDIT',
    heading_summary: 'Summary',
  },
  report: {
    set_in_report: 'Set in report',
    remove_from_report: 'Remove from report',
    company_logo: 'Company',
    profile_logo: 'Profile',
    customised_report: 'Customised report with your logo: €50 + VAT',
    download_report: 'Download report upon request: €250 + VAT',
    preview_report: 'Preview Report',
    generate_report: 'Generate Report',
    index: 'Index',
    back: 'Back',
    download: 'Download report',
    save: 'Save',
    cancel: 'Cancel',
    methodological_approach: 'Methodological approach',
    introduction: 'Introduction',
    company_profile: 'Company profile',
    emission_reduction: 'Mitigation activities',
    mission: 'Mission',
    vision: 'Vision',
    purpose_scope: 'Purpose and scope',
    regulatory_references: 'Regulatory references',
    ghg_boundaries: 'Boundaries of the GHG inventory',
    organizational_boundaries: 'Organizational boundaries',
    reporting_boundaries: 'Reporting boundaries',
    categorization: 'Categorization of direct and indirect GHG emissions',
    principles_adopted: 'Principles adopted',
    reporting_phases: 'GHG reporting phases',
    significance_definition: 'Definition of significance of GHG emissions',
    ghg_quantification: 'Quantification of GHG emissions',
    quantification_approach: 'Choice of quantification approach',
    topics_reported: 'Topics reported',
    category_1:
      'Category 1 – Direct emissions (stationary and mobile combustion)',
    category_2: 'Category 2 – Indirect emissions from imported energy',
    category_3: 'Category 3 – Other indirect emissions (transport and travel)',
    category_4: 'Category 4 – Purchased goods, waste, and leased assets',
    category_5: 'Category 5 – Downstream emissions and product impacts',
    category_6: 'Category 6 – Other indirect emissions',
    total_emissions: 'Total emissions',
    results_comment: 'Comment on the results',
    uncertainty_evaluation: 'GHG inventory quality management ',
    reduction_activities: 'Reduction activities',
    carbon_offsetting: 'Carbon offsetting activities: a tree for the future',
    quality_management: 'Role of the organisation in the verification activity',
    verification_role: 'Mitigation activities',
    glossary: 'Glossary',
  },
  close: {
    heading: 'Are you sure you want to leave?',
    logout_message: 'Are you sure you want to log out of your account?',
    subheading: 'We have automatically saved your progress up to this point.',
    subheading1:
      'You can resume your carbon footprint calculation at any time by accessing the initial table, where you will find the calculation partially completed.',
    subheading2:
      'Do you want to continue editing the calculation or close and save the current results?',
    button_yes: 'CLOSE AND SAVE',
    button_no: 'CONTINUE TO EDIT',
    yes: 'YES',
    no: 'NO',
  },
  paused: {
    heading: 'Carbon Footprint Pro is temporarily paused',
    body: 'The service is currently on hold: during this period it is not possible to log in to the platform or create new accounts.',
    thanks: 'We apologise for any inconvenience and thank you for your understanding.',
  },
};
